/**
 * Material-UI Component Overrides Index
 * 
 * Centralizes all Material-UI component style overrides for consistent theming.
 * Each override file handles plant-specific styling (JLR vs Standard).
 * 
 * Override Files:
 * - Paper: Basic paper component styling
 * - StepLabel: Stepper component labels
 * - Button: All button variants with JLR luxury styling
 * - Dialog: Modal and dialog components
 * - Popover: Dropdown and popover components
 * - TextField: Form input styling
 * - Table: Data table styling with hover effects
 * - Chip: Status chips and tags
 * - IconButton: Icon button interactions
 * 
 * How to Add New Overrides:
 * 1. Create new override file in this directory
 * 2. Import it here
 * 3. Add to Object.assign() call
 * 4. Follow existing pattern with theme parameter
 * 
 * Each override receives the full theme object with plantName property
 * for plant-specific styling decisions.
 */

import Paper from './Paper';
import StepLabel from './StepLabel';
import Button from './Button';
import Dialog from './Dialog';
import Popover from './Popover';
import TextField from './TextField';
import Table from './Table';
import Chip from './Chip';
import IconButton from './IconButton';

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Paper(theme),
    StepLabel(theme),
    Button(theme),
    Dialog(theme),
    Popover(theme),
    TextField(theme),
    Table(theme),
    Chip(theme),
    IconButton(theme),
  );
}
